/**
 * Shared Nominatim geocoder API for MapLibre GL Geocoder.
 * Uses OpenStreetMap's free geocoder with a custom User-Agent header.
 */

const USER_AGENT = 'fkw-map-hikes';

/**
 * Creates a `forwardGeocode` config object compatible with
 * @maplibre/maplibre-gl-geocoder.
 *
 * @param {object} [opts]
 * @param {string} [opts.userAgent=USER_AGENT]  — User-Agent header value
 * @returns {{ forwardGeocode: Function }}
 */
export function createGeocoderApi(opts = {}) {
  const userAgent = opts.userAgent || USER_AGENT;

  return {
    /**
     * Forward geocode implementation using Nominatim.
     * @param {object} config — from maplibre-gl-geocoder ({ query })
     * @returns {{ features: Array }}
     */
    forwardGeocode: async (config) => {
      const features = [];
      try {
        const url =
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
            config.query
          )}&format=geojson&polygon_geojson=1&addressdetails=1`;
        const response = await fetch(url, {
          headers: { 'User-Agent': userAgent },
        });
        const geojson = await response.json();
        for (const feature of geojson.features) {
          const center = [
            feature.bbox[0] + ((feature.bbox[2] - feature.bbox[0]) / 2),
            feature.bbox[1] + ((feature.bbox[3] - feature.bbox[1]) / 2),
          ];
          const point = {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: center,
            },
            place_name: feature.properties.display_name,
            properties: feature.properties,
            text: feature.properties.display_name,
            place_type: ['place'],
            center,
          };
          features.push(point);
        }
      } catch (e) {
        console.error(`Failed to forwardGeocode with error: ${e.message || e}`);
      }

      return { features };
    },
  };
}
